module.exports = __webpack_public_path__ + "Img_RabeaPeek_512px.png";